import React, {} from 'react';
import {SubtitleContext} from "../../contexts/SubtitleContext";　
import { LinkButton } from 'rc-easyui';
import Popup from "reactjs-popup";

const FindFrameSplit_Popup = ({_WaveformView}) => {
//網址判斷
//     useEffect(() => {
//
//     }, [location]);

    return <Popup
        open={_WaveformView.state.isShowFrameSplitError}
        modal
        closeOnDocumentClick
        onClose={()=>{
            _WaveformView.setState({isShowFrameSplitError:false});
        }}
        contentStyle={{width:'450px'  }}
    >
        <SubtitleContext.Consumer>
            {context =>
                <div
                    title="Find Frame Split"
                    style={{width:'450px'  }}
                    ref={ref=>_WaveformView.dlg=ref}
                >
                    <h3>Find Frame Split</h3>
                    <form  className=' '  >
                        <div className="form-group">
                            <label htmlFor="inputAddress">Enter Frame Split Value to Check: </label>

                            <input id="fFrameSplit" style={{width:'30px'}}  type="text" placeholder='Frame Split'
                                   value={_WaveformView.frameSplitErrorCheckValue}
                                   onChange={  (event) => {

                                       if(isNaN(event.target.value) === true){

                                       }else{
                                           _WaveformView.StyleData.fFrameSplit = parseFloat(event.target.value);
                                           localStorage.setItem('fFrameSplit',event.target.value);
                                           document.getElementById('fFrameSplit').value = _WaveformView.StyleData.fFrameSplit;

                                           //設定
                                           _WaveformView.props.context.setfFrameSplit(parseFloat(event.target.value));
                                           _WaveformView.frameSplitErrorCheckValue = parseFloat(event.target.value);
                                       }
                                   }}
                            />
                        </div>
                        <div style={{marginBottom:'20px'}}>
                            <LinkButton onClick={() => {

                                //開始搜尋
                                _WaveformView.searchFrameError_Manual(); //手動搜尋 

                                //關掉視窗
                                _WaveformView.setState({isShowFindFrameList:true});
                                _WaveformView.setState({isShowFrameSplitError:false});

                            }} >Confirm</LinkButton>
                        </div>
                    </form>
                </div>
            }
        </SubtitleContext.Consumer>
    </Popup> ;
};

export default FindFrameSplit_Popup;



// WEBPACK FOOTER //
// ./src/components/popup/FindFrameSplit_Popup.js